import {
  VISUALITZACIO_INICIALITZAR,
  VISUALITZACIO_OBTENIR_DADES
} from "../../actions/actionTypes";

const ESTAT_INICIAL = {};

const valors = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case VISUALITZACIO_INICIALITZAR:
      return ESTAT_INICIAL;

    case `${VISUALITZACIO_OBTENIR_DADES}_EN_CURS`:
      return {
        ...state
      };

    case `${VISUALITZACIO_OBTENIR_DADES}_SUCCESS`:
      return {
        ...state,
        especies: action.payload.especies,
        fenofases: action.payload.fenofases
      };

    case `${VISUALITZACIO_OBTENIR_DADES}_ERROR`:
      return {
        ...state,
        error: action.error
      };

    default:
      return state;
  }
};

export default valors;

export const getEspecies = state => state.especies;
export const getFenofases = state => state.fenofases;
export const getClasses = state => state.classes;
export const getEspeciesAsArray = state => {
  const especiesIndexatsPerId = getEspecies(state);

  return Object.keys(especiesIndexatsPerId).map(idEspecie => ({
    ...especiesIndexatsPerId[idEspecie],
    id: parseInt(idEspecie)
  }));
};
